import React, { Component } from 'react';
import QuickFilter from '../../Common/QuickFilter';
import { getUniqueSortedLabelValuePairsFromNumbers } from '../../utils';
import appConstants from '../../../../appConstants';
class ShipmentQuickFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      equipPref: {
        maxEquipSizes: [],
        minEquipSizes: [],
        fixedEquipSizes: []
      }
    };
  }

  componentDidMount() {
    this.props.glEventHub.on('updateEquipmentPreference', this.updateEquipmentPreferenceData);
  }

  componentWillUnmount() {
    this.props.glEventHub.off('updateEquipmentPreference', this.updateEquipmentPreferenceData);
  }

  updateEquipmentPreferenceData = ({ maxEquipSizes, minEquipSizes, fixedEquipSizes }) => {
    this.setState({
      equipPref: {
        maxEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(maxEquipSizes),
        minEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(minEquipSizes),
        fixedEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(fixedEquipSizes)
      }
    });
  };

  render() {
    return (
      <QuickFilter
        filterName={appConstants.IBPLANNING_QUICKFILTER_NAMES.SHIPMENTS_GRID}
        isStoreEvent
        customStore={{
          CustomerStore: { ...this.state.equipPref }
        }}
        {...this.props}
      />
    );
  }
}

export default ShipmentQuickFilter;
